import { Box, Skeleton, Stack } from "@mui/material";
import React from "react";

export const SkeletonLoading = () => {
  return (
    <Box sx={{ my: 3 }}>
      <Stack direction={"row"} spacing={1} width={"100%"}>
        <Skeleton variant="circular" width={50} height={50} />
        <Stack width={"80%"} direction={"column"} spacing={1}>
          <Skeleton variant="rectangular" width={"80%"} height={20} />
          <Skeleton variant="rectangular" width={"80%"} height={20} />
        </Stack>
      </Stack>
      <Stack>
        <Skeleton
          variant="rectangular"
          width={"100%"}
          height={100}
          sx={{ my: 1 }}
        />
        <Skeleton
          variant="rectangular"
          width={"100%"}
          height={40}
          sx={{ my: 1 }}
        />
        <Skeleton
          variant="rectangular"
          width={"100%"}
          height={40}
          sx={{ my: 1 }}
        />
      </Stack>
    </Box>
  );
};

export const SkeletonRepsLoading = () => {
  return (
    <Box sx={{ my: 3 }}>
      <Stack direction={"row"} spacing={1} width={"100%"}>
        <Skeleton variant="circular" width={50} height={50} />
        <Stack width={"80%"} direction={"column"} spacing={1}>
          <Skeleton variant="rectangular" width={"80%"} height={20} />
          <Skeleton variant="rectangular" width={"60%"} height={20} />
        </Stack>
      </Stack>
      <Stack sx={{ mt: 1 }}>
        <Skeleton
          variant="rectangular"
          width={"40%"}
          height={10}
          sx={{ my: "3px" }}
        />
        <Skeleton
          variant="rectangular"
          width={"40%"}
          height={10}
          sx={{ my: "3px" }}
        />
      </Stack>
    </Box>
  );
};

export const SkeletonChatLoading = () => {
  return (
    <Box sx={{ my: 3 }}>
      <Stack direction={"row"} spacing={1} width={"100%"}>
        <Skeleton variant="circular" width={50} height={50} />
        <Stack width={"80%"} direction={"column"} spacing={1}>
          <Skeleton variant="rectangular" width={"90%"} height={20} />

          <Skeleton variant="rectangular" width={"70%"} height={20} />
        </Stack>
      </Stack>
    </Box>
  );
};

export const SkeletonChatMessageLoading = () => {
  return (
    <Box sx={{  }}>
      <Stack direction={"row"} spacing={1} width={"100%"}>
        <Skeleton width={"100%"} height={100} />
      </Stack>
    </Box>
  );
};

export const SkeletonAccountLoading = () => {
  return (
    <Box sx={{ my: 3 }}>
      <Stack direction={"row"} spacing={1} width={"100%"}>
        <Stack width={"100%"} direction={"column"} spacing={1}>
          <Skeleton variant="rectangular" width={"80%"} height={20} />
          <Skeleton variant="rectangular" width={"80%"} height={20} />
        </Stack>
      </Stack>
      <Stack>
        <Skeleton
          variant="rectangular"
          width={"100%"}
          height={100}
          sx={{ my: 1 }}
        />
        <Skeleton
          variant="rectangular"
          width={"100%"}
          height={40}
          sx={{ my: 1 }}
        />
        <Skeleton
          variant="rectangular"
          width={"100%"}
          height={40}
          sx={{ my: 1 }}
        />
        <Skeleton
          variant="rectangular"
          width={"100%"}
          height={100}
          sx={{ my: 1 }}
        />
        <Skeleton
          variant="rectangular"
          width={"100%"}
          height={40}
          sx={{ my: 1 }}
        />
      </Stack>
    </Box>
  );
};

export const SkeletonRepsAccountLoading = () => {
  return (
    <Box sx={{ my: 3 }}>
      <Stack>
        <Skeleton
          variant="rectangular"
          width={"100%"}
          height={180}
          sx={{ my: 1 }}
        />
        <Stack
          direction={"row"}
          spacing={1}
          width={"100%"}
          justifyContent={"space-between"}
          sx={{ my: 2 }}
        >
          <Skeleton variant="circular" width={80} height={80} />
          <Stack
            width={"80%"}
            direction={"column"}
            alignItems={"flex-end"}
            spacing={1}
          >
            <Skeleton variant="rectangular" width={"25%"} height={30} />
          </Stack>
        </Stack>
        <Stack width={"100%"} direction={"column"} spacing={1}>
          <Skeleton variant="rectangular" width={"50%"} height={20} />
          <Skeleton variant="rectangular" width={"40%"} height={20} />
        </Stack>
        <Skeleton
          variant="rectangular"
          width={"100%"}
          height={40}
          sx={{ my: 1 }}
        />
        <Skeleton
          variant="rectangular"
          width={"100%"}
          height={40}
          sx={{ my: 1 }}
        />
        <Skeleton
          variant="rectangular"
          width={"100%"}
          height={40}
          sx={{ my: 1 }}
        />
        <Skeleton
          variant="rectangular"
          width={"100%"}
          height={40}
          sx={{ my: 1 }}
        />
      </Stack>
    </Box>
  );
};

export const SkeletonMainAccountLoading = () => {
  return (
    <Box sx={{ my: 3 }}>
      <Stack>
        <Skeleton
          variant="rectangular"
          width={"100%"}
          height={180}
          sx={{ my: 1 }}
        />
        <Stack
          direction={"row"}
          spacing={1}
          width={"100%"}
          justifyContent={"space-between"}
          sx={{ my: 2 }}
        >
          <Skeleton variant="circular" width={80} height={80} />
          <Stack
            width={"80%"}
            direction={"column"}
            alignItems={"flex-end"}
            spacing={1}
          >
            <Skeleton variant="rectangular" width={"25%"} height={30} />
          </Stack>
        </Stack>

        <Skeleton
          variant="rectangular"
          width={"100%"}
          height={60}
          sx={{ my: 1 }}
        />

        <Box sx={{ my: 3 }}>
          <Stack direction={"row"} spacing={1} width={"100%"}>
            <Skeleton variant="circular" width={50} height={50} />
            <Stack width={"80%"} direction={"column"} spacing={1}>
              <Skeleton variant="rectangular" width={"80%"} height={20} />
              <Skeleton variant="rectangular" width={"60%"} height={20} />
            </Stack>
          </Stack>
          <Stack sx={{ mt: 1 }}>
            <Skeleton
              variant="rectangular"
              width={"90%"}
              height={150}
              sx={{ my: "3px" }}
            />
            <Skeleton
              variant="rectangular"
              width={"90%"}
              height={30}
              sx={{ my: "3px" }}
            />
            <Skeleton
              variant="rectangular"
              width={"90%"}
              height={30}
              sx={{ my: "3px" }}
            />
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
};

export const SkeletonAccountPostLoading = () => {
  return (
    <Box sx={{ my: 3 }}>
      <Stack direction={"row"} spacing={1} width={"100%"}>
        <Skeleton variant="circular" width={50} height={50} />
        <Stack width={"80%"} direction={"column"} spacing={1}>
          <Skeleton variant="rectangular" width={"50%"} height={15} />
          <Skeleton variant="rectangular" width={"60%"} height={15} />
          <Skeleton variant="rectangular" width={"70%"} height={15} />
        </Stack>
      </Stack>
      <Stack sx={{ mt: 1 }}>
        <Skeleton
          variant="rectangular"
          width={"100%"}
          height={220}
          sx={{ my: "3px" }}
        />
        <Skeleton
          variant="rectangular"
          width={"100%"}
          height={80}
          sx={{ my: "3px" }}
        />
        <Skeleton
          variant="rectangular"
          width={"100%"}
          height={40}
          sx={{ my: "3px" }}
        />
      </Stack>
    </Box>
  );
};

export const SkeletonAccountReplyLoading = () => {
  return (
    <Box sx={{ my: 3 }}>
      <Stack direction={"row"} alignItems={"center"} spacing={1} width={"100%"}>
        <Skeleton variant="circular" width={40} height={40} />

        <Skeleton variant="rectangular" width={"70%"} height={15} />
      </Stack>
      <Stack direction={"row"} spacing={1} width={"100%"} p={3}>
        <Skeleton variant="circular" width={40} height={40} />
        <Stack width={"80%"} direction={"column"} spacing={1}>
          <Skeleton variant="rectangular" width={"70%"} height={20} />
          <Skeleton variant="rectangular" width={"70%"} height={20} />
        </Stack>
      </Stack>
      <Stack sx={{ mt: 1 }}>
        <Skeleton
          variant="rectangular"
          width={"50%"}
          height={40}
          sx={{ my: "3px" }}
        />
      </Stack>
    </Box>
  );
};

export const SkeletonLoadingUnauthoried = () => {
  return (
    <Box sx={{ my: 3 }}>
      <Stack direction={"row"} spacing={1} width={"100%"} sx={{ mb: 3 }}>
        <Skeleton variant="circular" width={50} height={50} />
        <Stack width={"80%"} direction={"column"} spacing={1}>
          <Skeleton variant="rectangular" width={"80%"} height={20} />
          <Skeleton variant="rectangular" width={"80%"} height={20} />
        </Stack>
      </Stack>
      <Stack sx={{ my: 3 }}>
        <Skeleton
          variant="rectangular"
          width={"100%"}
          height={60}
          sx={{ my: 1 }}
        />
        <Skeleton
          variant="rectangular"
          width={"100%"}
          height={40}
          sx={{ my: 1 }}
        />

        <Skeleton
          variant="rectangular"
          width={"100%"}
          height={200}
          sx={{ my: 1 }}
        />
      </Stack>
    </Box>
  );
};
